import { configureStore } from "@reduxjs/toolkit";
import AppSlice from "./appslice";



const store = configureStore({
    reducer: {
      // This handle the state of the app.
      app: AppSlice.reducer
    }
  });


  export default store;
  export type RootState = ReturnType<typeof store.getState>;
  export type AppDispatch = typeof store.dispatch;